import { render, staticRenderFns } from "./NotificationMenu.vue?vue&type=template&id=7e56aac2&scoped=true&"
import script from "./NotificationMenu.vue?vue&type=script&lang=js&"
export * from "./NotificationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e56aac2",
  null
  
)

export default component.exports